import { getApiBaseUrl } from '@/services/api/base-url';
import type { RumBeaconPayload } from './types';

/**
 * Fire-and-forget delivery to `POST /v1/rum` (unauthenticated, `ui_api/rum/`).
 * The JSON body is sent as `text/plain` to stay a CORS simple request — the
 * beacon often fires mid-unload, where a preflight round-trip gets dropped;
 * the server parses the body regardless of content type. `sendBeacon` is
 * preferred (survives unload), fetch keepalive is the fallback.
 */
export function sendRumBeacon(payload: RumBeaconPayload): void {
  try {
    const url = `${getApiBaseUrl()}/v1/rum`;
    const body = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });

    if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon(url, body)) {
      return;
    }

    void fetch(url, { method: 'POST', body, keepalive: true, credentials: 'omit' }).catch(() => {});
  } catch {
    // telemetry is best-effort
  }
}
